import { useCallback } from 'react';
import { produce } from 'immer';

import type { Period } from '@/utilities/timeSeriesPeriodMap';

import useUser from '@/hooks/useUser';

const DEFAULT_HOLDINGS_PERIOD: Period = '3M';

export function useWatchlistPeriod() {
  const {
    data: user,
    mutate: updateUserSettings,
    setQueryData: setUserSettings,
  } = useUser();

  const watchlistPeriod =
    user.defaultWatchlistPeriod ?? DEFAULT_HOLDINGS_PERIOD;

  const setWatchlistPeriod = useCallback(
    (period: Period) => {
      setUserSettings((state) =>
        produce(state, (draft) => {
          draft.defaultWatchlistPeriod = period;
        })
      );

      updateUserSettings({
        settings: {
          default_watchlist_period: period,
        },
      });
    },
    [setUserSettings, updateUserSettings]
  );

  return [watchlistPeriod, setWatchlistPeriod] as const;
}
